import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BadgeState = _resolveComponent("BadgeState")!
  const _component_ResourceTable = _resolveComponent("ResourceTable")!

  return (_openBlock(), _createBlock(_component_ResourceTable, {
    schema: $props.schema,
    headers: $options.headers,
    rows: _ctx.rows,
    loading: _ctx.loading,
    "use-query-params-for-simple-filtering": $props.useQueryParamsForSimpleFiltering,
    namespaced: $props.schema.attributes.namespaced,
    fetchSecondaryResources: "fetchSecondaryResources"
  }, {
    "cell:enabled": _withCtx(({row}) => [
      _createVNode(_component_BadgeState, {
        color: row.spec.enabled ? 'bg-success' : 'badge-disabled',
        label: row.spec.enabled ? _ctx.t('generic.enabled') : _ctx.t('generic.disabled') 
      }, null, 8, ["color", "label"])
    ]),
    _: 1
  }, 8, ["schema", "headers", "rows", "loading", "use-query-params-for-simple-filtering", "namespaced"]))
}